module.exports = __webpack_public_path__ + "static/media/download.167f2d1f.svg";